import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowLeft } from "lucide-react";
import { COMPANY } from "../constants/company";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function Support() {
  return (
    <div className="min-h-screen bg-background" data-testid="support-page">
      <header className="border-b border-border bg-background/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="support-logo-link" className="flex items-center">
            <img src="/logo.png" alt="Laronta Pro Tax Services" className="h-10 w-auto rounded-sm" />
          </Link>
          <Button asChild variant="ghost" size="sm">
            <Link to="/" data-testid="support-back-link"><ArrowLeft className="w-4 h-4 mr-1" /> Home</Link>
          </Button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-16">
        <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground font-medium">We're here to help</p>
        <h1 className="mt-3 text-4xl sm:text-5xl font-heading font-semibold tracking-tighter">Support</h1>
        <p className="mt-4 text-muted-foreground max-w-xl">
          Questions about your intake, documents, or an upcoming appointment? Reach out — a member of our Taylorsville office will get back to you.
        </p>
        <Card className="mt-10" data-testid="support-contact-card">
          <CardHeader>
            <CardTitle className="font-heading text-2xl">Contact {COMPANY.name}</CardTitle>
          </CardHeader>
          <CardContent className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
            <div className="flex items-start gap-3">
              <Phone className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium">Phone</p>
                <a href={COMPANY.phoneHref} data-testid="support-phone-link" className="text-muted-foreground hover:text-primary transition-colors">{COMPANY.phone}</a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium">Email</p>
                <a href={COMPANY.emailHref} data-testid="support-email-link" className="text-muted-foreground hover:text-primary transition-colors">{COMPANY.email}</a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium">Office</p>
                <p className="text-muted-foreground">{COMPANY.address}<br />{COMPANY.city}, {COMPANY.state} {COMPANY.zip}</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium">Hours</p>
                {COMPANY.hours.map((h) => (
                  <p key={h.days} className="text-muted-foreground">{h.days}: {h.time}</p>
                ))}
              </div>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
